import { render, staticRenderFns } from "./CategoryCascader.vue?vue&type=template&id=1a5d6a8d&scoped=true"
import script from "./CategoryCascader.vue?vue&type=script&lang=js"
export * from "./CategoryCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d6a8d",
  null
  
)

export default component.exports